<template>
  <!-- DESAYUNO -->
  <div class="desayuno">
    <div class="desayuno__fondo">
      <div class="container-fluid desayuno__container">
        <div class="row desayuno__row justify-content-center">
          <div
            class="
              col-lg-11 col-md-11 col-sm-11 col-12
              desayuno__col desayuno__col--titulo
              text-start
              pt-3
              mb-0
            "
          >
            <h1 class="desayuno__h1 mb-0" :style="{ color: colorPrimario }">
              Desayuno
            </h1>
            <router-link
              to="/home"
              class="desayuno__link-home"
              aria-label="Acceder a este desayuno"
              :style="{ color: colorPrimario }"
            >
              <IconHome  />
              Volver al Home
            </router-link>
            <div class="row desayuno__row justify-content-center">
              <div class="col-lg-9 col-md-8 col-11 desayuno__col">
                <p class="desayuno__subtitulo mt-2">
                  ¡Disfruta los beneficios que tenemos para ti y tu familia!
                  Conócelos y solicítalos aquí.
                </p>
              </div>
              <div class="col-lg-3 col-md-4 col-8 desayuno__col">
                <nav class="nav-filtro">
                  <div
                    class="nav nav-tabs nav-filtro__tabs ms-auto"
                    id="nav-tab"
                    role="tablist"
                  >
                    <button
                      class="nav-link active nav-filtro__nav-tabs"
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="true"
                      @click="aSolicitar"
                      :style="{
                        backgroundColor: butonActive ? colorPrimario : '#fff',
                        borderRadius: '20px',
                        color: butonActive ? '#fff !important' : '#6B6E7F',
                      }"                     
                    >
                      Solicitar
                    </button>
                    <button
                      class="nav-link nav-filtro__nav-tabs"
                      id="nav-profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-profile"
                      type="button"
                      role="tab"
                      aria-controls="nav-profile"
                      aria-selected="false"
                      @click="aHistorial"
                      :style="{
                        backgroundColor: !butonActive ? colorPrimario : '#fff',
                        borderRadius: '20px',
                        color: !butonActive ? '#fff !important' : '#6B6E7F',
                      }"
                    >
                      Historial
                    </button>
                  </div>
                </nav>
              </div>
            </div>
          </div>
          <div class="col-11 desayuno__col">
            <hr class="desayuno__hr" />
          </div>
        </div>
        <div class="row desayuno__row justify-content-center">
          <div
            class="
              col-lg-11 col-md-11 col-sm-11 col-11
              px-0
              desayuno__col desayuno__div-solicitar
            "
          >
            <div class="row desayuno__row justify-content-center">
              <div
                class="
                  col-lg-12 col-md-12 col-sm-12 col-12
                  desayuno__col
                  px-2
                  py-3
                  mb-2
                "
              >
                <div class="row desayuno__row">
                  <div
                    class="
                      col-lg-6 col-md-6 col-12
                      desayuno__col
                      text-start
                      mb-3
                      px-0
                    "
                  >
                    <div class="desayuno__formulario-a mx-auto py-3">
                      <div
                        class="row desayuno__row justify-content-center px-3"
                      >
                        <div class="col-12 desayuno__col text-start">
                          <div class="row desayuno__">
                            <div
                              class="
                                col-lg-12 col-md-12 col-12
                                desayuno__col
                                text-start
                              "
                            >
                              <h2 class="desayuno__h2-formulario mb-0">
                                Confirma tus datos
                              </h2>
                            </div>
                          </div>

                          <hr class="desayuno__hr mb-3 mt-1" />
                        </div>

                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            desayuno__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label desayuno__label"
                            >Teléfono</label
                          >
                          <input
                            type="number"
                            class="form-control desayuno__input"
                            id="exampleFormControlInput1"
                            placeholder="988765432"
                          />
                        </div>
                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            desayuno__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label desayuno__label"
                            >Mail</label
                          >
                          <input
                            type="email"
                            class="form-control desayuno__input"
                            id="exampleFormControlInput1"
                            placeholder="cliente@cliente.cl"
                          />
                        </div>
                      </div>
                      <div
                        class="
                          row
                          desayuno__row
                          justify-content-center
                          px-3
                          mt-2
                        "
                      >
                        <div class="col-12 desayuno__col text-start">
                          <h3 class="desayuno__h3-formulario">
                            Información turno
                          </h3>
                        </div>
                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            desayuno__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label desayuno__label"
                            >Turno</label
                          >
                          <!-- <select
                            class="form-select desayuno__select selectpicker"
                            aria-label="Default select example"
                          >
                            <option class="desayuno__option" selected>
                              7x7
                            </option>
                            <option class="desayuno__option" value="1">
                              5x5
                            </option>
                            <option class="desayuno__option" value="2">
                              4x4
                            </option>
                            <option class="desayuno__option" value="3">
                              3x3
                            </option>
                          </select> -->
                          <div class="dropdown dropdown-selector">
                            <button
                              class="dropdown-toggle dropdown-selector__toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Turno
                              <font-awesome-icon icon="fa-solid fa-caret-up" class=" ms-2 dropdown-selector__icono-flecha"></font-awesome-icon>
                             <font-awesome-icon icon="fa-solid fa-caret-down" class="ms-2 dropdown-selector__icono-flecha-b"></font-awesome-icon>
                            </button>
                            <ul class="dropdown-menu dropdown-selector__menu">
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >7x7</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >5x5</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >4x4</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >3x3</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            desayuno__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label desayuno__label"
                            >Team</label
                          >
                          <!-- <select
                            class="form-select desayuno__select selectpicker"
                            aria-label="Default select example"
                          >
                            <option class="desayuno__option" value="0">
                              1
                            </option>
                            <option class="desayuno__option" selected value="1">
                              2
                            </option>
                            <option class="desayuno__option" value="2">
                              3
                            </option>
                            <option class="desayuno__option" value="3">
                              4
                            </option>
                          </select> -->
                          <div class="dropdown dropdown-selector">
                            <button
                              class="dropdown-toggle dropdown-selector__toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Team
                              <font-awesome-icon icon="fa-solid fa-caret-up" class=" ms-2 dropdown-selector__icono-flecha"></font-awesome-icon>
                             <font-awesome-icon icon="fa-solid fa-caret-down" class="ms-2 dropdown-selector__icono-flecha-b"></font-awesome-icon>
                            </button>
                            <ul class="dropdown-menu dropdown-selector__menu">
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >1</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >2</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >3</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >4</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="row desayuno__row px-3 mt-2">
                        <div class="col-12 desayuno__col text-start">
                          <h3 class="desayuno__h3-formulario">
                            Detalles del servicio
                          </h3>
                        </div>
                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            desayuno__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label desayuno__label"
                            >Pabellón</label
                          >
                          <!-- <select
                            class="form-select desayuno__select selectpicker"
                            aria-label="Default select example"
                          >
                            <option class="desayuno__option" selected>
                              Seleccionar
                            </option>
                            <option class="desayuno__option" value="1">
                              Valor 1
                            </option>
                            <option class="desayuno__option" value="2">
                              Valor 2
                            </option>
                            <option class="desayuno__option" value="3">
                              Valor 3
                            </option>
                          </select> -->
                          <div class="dropdown dropdown-selector">
                            <button
                              class="dropdown-toggle dropdown-selector__toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Seleccionar
                              <font-awesome-icon icon="fa-solid fa-caret-up" class=" ms-2 dropdown-selector__icono-flecha"></font-awesome-icon>
                             <font-awesome-icon icon="fa-solid fa-caret-down" class="ms-2 dropdown-selector__icono-flecha-b"></font-awesome-icon>
                            </button>
                            <ul class="dropdown-menu dropdown-selector__menu">
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >Valor 1</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >Valor 2</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >Valor 3</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            desayuno__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label desayuno__label"
                            >Habitación</label
                          >
                          <!-- <select
                            class="form-select desayuno__select selectpicker"
                            aria-label="Default select example"
                          >
                            <option class="desayuno__option" selected>
                              Seleccionar
                            </option>
                            <option class="desayuno__option" value="1">
                              Valor 1
                            </option>
                            <option class="desayuno__option" value="2">
                              Valor 2
                            </option>
                            <option class="desayuno__option" value="3">
                              Valor 3
                            </option>
                          </select> -->
                          <div class="dropdown dropdown-selector">
                            <button
                              class="dropdown-toggle dropdown-selector__toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Seleccionar
                              <font-awesome-icon icon="fa-solid fa-caret-up" class=" ms-2 dropdown-selector__icono-flecha"></font-awesome-icon>
                             <font-awesome-icon icon="fa-solid fa-caret-down" class="ms-2 dropdown-selector__icono-flecha-b"></font-awesome-icon>
                            </button>
                            <ul class="dropdown-menu dropdown-selector__menu">
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >Valor 1</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >Valor 2</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >Valor 3</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            desayuno__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label desayuno__label"
                            >Ubicación cama</label
                          >
                          <!-- <select
                            class="form-select desayuno__select selectpicker"
                            aria-label="Default select example"
                          >
                            <option class="desayuno__option" selected>
                              Seleccionar
                            </option>
                            <option class="desayuno__option" value="1">
                              Valor 1
                            </option>
                            <option class="desayuno__option" value="2">
                              Valor 2
                            </option>
                            <option class="desayuno__option" value="3">
                              Valor 3
                            </option>
                          </select> -->
                          <div class="dropdown dropdown-selector">
                            <button
                              class="dropdown-toggle dropdown-selector__toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Ubicación
                              <font-awesome-icon icon="fa-solid fa-caret-up" class=" ms-2 dropdown-selector__icono-flecha"></font-awesome-icon>
                             <font-awesome-icon icon="fa-solid fa-caret-down" class="ms-2 dropdown-selector__icono-flecha-b"></font-awesome-icon>
                            </button>
                            <ul class="dropdown-menu dropdown-selector__menu">
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >Valor 1</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >Valor 2</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >Valor 3</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div
                          class="
                            col-lg-6 col-md-12 col-12
                            px-2
                            desayuno__col
                            text-start
                            mb-3
                          "
                        >
                          <label
                            for="select-2"
                            class="form-label desayuno__label"
                            >Ubicación clóset</label
                          >
                          <!-- <select
                            class="form-select desayuno__select selectpicker"
                            aria-label="Default select example"
                          >
                            <option class="desayuno__option" selected>
                              Seleccionar
                            </option>
                            <option class="desayuno__option" value="1">
                              Valor 1
                            </option>
                            <option class="desayuno__option" value="2">
                              Valor 2
                            </option>
                            <option class="desayuno__option" value="3">
                              Valor 3
                            </option>
                          </select> -->
                          <div class="dropdown dropdown-selector">
                            <button
                              class="dropdown-toggle dropdown-selector__toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Seleccionar
                              <font-awesome-icon icon="fa-solid fa-caret-up" class=" ms-2 dropdown-selector__icono-flecha"></font-awesome-icon>
                             <font-awesome-icon icon="fa-solid fa-caret-down" class="ms-2 dropdown-selector__icono-flecha-b"></font-awesome-icon>
                            </button>
                            <ul class="dropdown-menu dropdown-selector__menu">
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >Valor 1</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >Valor 2</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item dropdown-selector__item"
                                  href="#"
                                  >Valor 3</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              col-lg-11 col-md-11 col-sm-11 col-11
              desayuno__col desayuno__div-historial
              bg-white
            "
          ></div>
        </div>
      </div>
    </div>
  </div>
  <!-- fin DESAYUNO -->
</template>

<script>
import IconHome from "../../../assets/img/intranet/NavVertical/IconHome.vue";
// @ is an alias to /src
export default {
  components: {
    IconHome,
  },
  name: "Desayuno",
  data() {
    return {
      butonActive: true,
    };
  },
  computed: {},
  methods: {
    aSolicitar() {
      this.butonActive = true,
      document
        .querySelector(".desayuno__div-solicitar")
        .classList.remove("d-none");
      document
        .querySelector(".desayuno__div-historial")
        .classList.add("d-none");
    },
    aHistorial() {
      this.butonActive = false,
      document
        .querySelector(".desayuno__div-solicitar")
        .classList.add("d-none");
      document
        .querySelector(".desayuno__div-historial")
        .classList.remove("d-none");
    },
  },
};
</script>

